import calculateMunicipalityKey from "../../Hooks/Municipality";

export default function themeLoader(){


    const municipality = calculateMunicipalityKey();
    if (municipality.name === '')
        return;

    loadStyleSheet(`/${municipality.name}.css`);
    setIcons(municipality.name)
    
    function loadStyleSheet(url: string){
        var sheet = document.createElement('link');
        sheet.rel = 'stylesheet';
        sheet.href = url;
        sheet.type = 'text/css';
        document.head.appendChild(sheet);
    }

    function setIcons(municipality: string) {
        const headerLinks = document.head.getElementsByTagName('link')

        var favIcon = headerLinks.namedItem('favicon');
        if(favIcon){
            favIcon.href = `/${municipality}/favicon.ico`
        }

        var touchIcon = headerLinks.namedItem('touchicon');
        if(touchIcon){
            touchIcon.href = `/${municipality}/apple-touch-icon.png`
        }
    }
}